import { useState, useEffect } from 'react';

import { socket } from 'api';
import { prepareVideoUrls } from 'services';
import { isUrlsOk } from './hook-use-video-urls.func';

const test = false;
const testStreams = {
  camera_1: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  camera_2: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  camera_3: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  // camera_4: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  // camera_5: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  // camera_6: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
  // camera_7: '/getVideo/http://10.105.0.123:8888/screen.mjpg',
};

/**
 * use video urls
 * @param {*} props
 * @returns
 */
export const useVideoUrls = (props) => {
  const { sendControlMsg, streams, id, mode } = props;
  const [cams, setCams] = useState(null);

  /**
   * get video urls
   * @param {*} force
   */
  const getVideoUrls = (force = false) => {
    if (!isUrlsOk(streams) || force) {
      sendControlMsg('get_video_urls');
    } else {
      if (streams) {
        setCams(prepareVideoUrls(test ? testStreams : streams));
      }
    }
  };

  /**
   * get urls from socket
   */
  useEffect(() => {
    const onGetUrls = (msg) => {
      if (msg.target === id) {
        // if (self._ismounted) {
        setCams(prepareVideoUrls(msg));
        // }
      }
    };
    socket.on('get_video_urls', onGetUrls);
    // sendControlMsg('get_state');

    return () => {
      socket.off('get_video_urls', onGetUrls);
    };
  }, []);

  /**
   * on change urls
   */
  useEffect(() => {
    // console.log("cams1", cams, mode);
    if (mode !== undefined && cams === null) {
      // console.log("mode", mode);
      getVideoUrls();
    }
  }, [mode, cams /*, streams*/]);

  return { cams };
};
